export default "__VITE_ASSET__BiRmtc$e__"